export default __webpack_public_path__ + "static/media/consorcioLogo.b1b0c50f.svg";